module.exports = __webpack_public_path__ + "img/cover.f272f23a.png";